import { z } from "zod";
import { Todo } from "./todos.js";

export const Ok = z.object({
  items: z.array(Todo),
});

export const Err = z.string();
